module.exports = __webpack_public_path__ + "img/111.08876ca3.gif";